import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {Content} from '../../../../shared/models/content';
import {AppActions} from '../../../actions';
import {skbInitialData} from './skb';
export interface ContentState {
  data: Content;
  isLoaded: boolean;
}

const initialState: ContentState = {
  isLoaded: false,
  data: skbInitialData,
};

export const contentSlice = createSlice<ContentState, SliceCaseReducers<ContentState>>({
  name: '@@eskso/resources/content',
  initialState,
  reducers: {
    setContent: (state, action: PayloadAction<Content>) => {
      state.data = action.payload;
    },
    setContentLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});
